import { fmtNum } from '../yeni-design/primitives';
import { Bilgi } from '../satis-analiz/Bilgi';
import { oranMetni } from '../satis-analiz/bicim';

/**
 * G4b/C4 — 990050 (Şube Stok Güvenilirliği) satırı: lokasyon × kategori tanesinde döner
 * (135-gizova-turetilmis-olculer.sql, ds başlığı "990050 Şube Stok Güvenilirliği"). Sözleşme
 * kolonları: sube, kategori, urun_sayisi, supheli_urun, supheli_oran, negatif_miktar.
 */
export interface SubeGuvenilirlikSatiri {
  sube: string;
  kategori: string;
  urun_sayisi: number;
  supheli_urun: number;
  supheli_oran: number;
  negatif_miktar: number;
}

/**
 * G4b/final-fix (Ayrıca notu) — `KayipBlok.tsx`'in `lokasyonListesi`si ile `StokFiltreSeridi.tsx`'in
 * `subeListesi`si BİREBİR AYNIYDI (990050'den benzersiz, sıralı lokasyon adları); tek yere alındı.
 */
export function subeListesi(rows: Pick<SubeGuvenilirlikSatiri, 'sube'>[]): string[] {
  const kume = new Set<string>();
  for (const r of rows) {
    const ad = String(r.sube ?? '').trim();
    if (ad) kume.add(ad);
  }
  return Array.from(kume).sort((a, b) => a.localeCompare(b, 'tr'));
}

/**
 * §4.5 — metin SABİT KODLANMAZ, `satirlar`dan üretilir. 990050 lokasyon × kategori tanesinde
 * döner: bir şubenin TÜM kategorileri toplanır (Σsupheli_urun / Σurun_sayisi), kategori bazlı
 * oranların ortalaması ALINMAZ (S6 ile aynı kural). `satirlar` çağıranın elindeki TÜM 990050
 * satırları olabilir — burada `sube`'ye göre süzülür, böylece bileşen kendi verisini kendi çıkarır.
 */
export function subeGuvenilirlikMetni(sube: string, satirlar: SubeGuvenilirlikSatiri[]): string | null {
  let urun = 0;
  let supheli = 0;
  for (const s of satirlar) {
    if (s.sube !== sube) continue;
    urun += Number(s.urun_sayisi) || 0;
    supheli += Number(s.supheli_urun) || 0;
  }
  if (urun <= 0) return null;
  const oran = (100 * supheli) / urun;
  return `Bu şubenin stok kaydı şüpheli: ${sube}'te ${fmtNum(urun)} üründen ${fmtNum(supheli)}'i (${oranMetni(oran, 1)}) negatif bakiyeli.`;
}

/**
 * Blok DEĞİL, rozet: şube kırılımı gösteren bir kartın köşesine (`SectionCard`'ın `actions` yuvasına)
 * konur — `Bilgi` (ⓘ) zaten o yuvada durmaya uygun küçük bir düğme. Veri yoksa (şubenin 990050
 * satırı yok ya da toplam ürün 0) `null` döner — rozet hiç görünmez.
 */
export function SubeRozeti({
  sube, satirlar, testid,
}: {
  sube: string;
  satirlar: SubeGuvenilirlikSatiri[];
  testid?: string;
}) {
  const metin = subeGuvenilirlikMetni(sube, satirlar);
  if (metin === null) return null;
  const t = testid ?? `sube-rozet-${sube}`;
  return (
    <span data-testid={t}>
      <Bilgi testid={`${t}-bilgi`} metin={metin} />
    </span>
  );
}
